import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { zoomSdkApi } from './zoomSdkQueries'
import sessionSlice from './session'
import canvasSlice from './canvas'
import modalSlice from './modal'
import userSlice from './user'
import meetingSlice from './meeting'
import paginationSlice from './pagination'
import hostSettingsSlice from './hostSettings'
import { appApi } from './appApiQueries'
import { rtkQueryErrorMiddleware } from './rtkErrorLogger'
import pageSlice from './page'
import allSessionsSlice from './allSessions'

export const store = configureStore({
  reducer: {
    [appApi.reducerPath]: appApi.reducer,
    [zoomSdkApi.reducerPath]: zoomSdkApi.reducer,
    canvas: canvasSlice.reducer,
    modal: modalSlice.reducer,
    session: sessionSlice.reducer,
    user: userSlice.reducer,
    page: pageSlice.reducer,
    pagination: paginationSlice.reducer,
    hostSettings: hostSettingsSlice.reducer,
    meeting: meetingSlice.reducer,
    allSessionsData: allSessionsSlice.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: [
          'payload.props.setSelectedGroupOnCreation',
          'meta.baseQueryMeta.request',
          'meta.baseQueryMeta.response',
        ],
        ignoredPaths: ['modal.props.setSelectedGroupOnCreation'],
      },
    }).concat(
      zoomSdkApi.middleware,
      appApi.middleware,
      rtkQueryErrorMiddleware
    ),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
